<template>
    <div class="user-agency-edit">
        <data-form title="Edit Agency Association"
                   key="user-agency-edit"
                   save-button-label="Save"
                   :field-model="agencyUser"
                   :field-groups="fieldGroups"
                   :disabledFields="disabledFields"
                   :on-submit-handler="onSubmit"
                   :cancelRoute="`/user/view/${userId}`"
                   :load-model-instance="loadModelInstance"
                   submit-success-message="User agency info updated"
                   submit-error-message="Error updating">
        </data-form>
    </div>
</template>

<script>

import Vue from 'vue'
import AgencyUser from '@/models/AgencyUser'

export default Vue.extend({
    name: 'UserAgencyEdit',
    props: {
        userId: Number,
        agencyUserId: Number,
    },
    data () {
        return {
            agencyUser: AgencyUser,
            disabledFields: ['user_full_name', 'agency_name']
        }
    },
    computed: {
        fieldGroups () {
            let fieldGroupLeft = ['user_full_name', 'agency_name']
            let fieldGroupRight = [
                'is_program_admin',
                'is_owners_representative',
                'is_project_manager',
                'department',
                'company_name'
            ]
            return [fieldGroupLeft, fieldGroupRight]
        },
    },
    methods: {
        async loadModelInstance () {
            return this.$api.getItem(this, 'agency-user', this.agencyUserId)
                .then((agencyUser) => {
                    return this.$api.getItem(this, 'user', agencyUser.user_id)
                        .then((user) => {
                            agencyUser.user_full_name = user.full_name
                            return agencyUser
                        })
                        .then((agencyUser) => {
                            return this.$api.getItem(this, 'agency', agencyUser.agency_id)
                                .then((agency) => {
                                    agencyUser.agency_name = agency.name
                                    return agencyUser
                                })
                        })
                })
        },
        onSubmit (modelInstance) {
            return this.$api.updateItem(this, 'agency-user', modelInstance)
                .then(async (response) => {
                    this.$router.push(`/user/view/${this.userId}`)
                })
        }
    },
})

</script>
